import React from 'react';
import './App.css';
import Dashboard from './components/dashboard/Dashboard';
import { BrowserRouter as Router } from 'react-router-dom';
function App() {
  return (
    <Router basename={process.env.PUBLIC_URL || '/'}>
      <div className="App">
        <Dashboard />
      </div>
    </Router>
  );
}

export default App;
